export default __webpack_public_path__ + "static/soehne-mono-web-leicht-kursiv-98a06026e7d87347429decb9fda2e510.eot";